import { AnySpecificPaymentMethodResponse } from '../../services/interface/any-specific-payment-method-response';
import {
	BillingCardPaymentMethodResponse,
	BillingBankAccountPaymentMethodResponse,
	BillingFinanceHousePaymentMethodResponse,
	BillingMSPPaymentMethodResponse,
	BillingOffSystemPaymentMethodResponse,
	BillingWalletPaymentMethodResponse,
} from '../../services/managedPaymentsApi';

// Type guard for BillingCardPaymentMethodResponse
export function isBillingCardPaymentMethod(
	pm: AnySpecificPaymentMethodResponse,
): pm is BillingCardPaymentMethodResponse {
	return pm.$type === 'BillingCardPaymentMethod';
}

// Type guard for BillingBankAccountPaymentMethodResponse
export function isBillingBankAccountPaymentMethod(
	pm: AnySpecificPaymentMethodResponse,
): pm is BillingBankAccountPaymentMethodResponse {
	return pm.$type === 'BillingBankAccountPaymentMethod';
}

// Type guard for BillingFinanceHousePaymentMethodResponse
export function isBillingFinanceHousePaymentMethod(
	pm: AnySpecificPaymentMethodResponse,
): pm is BillingFinanceHousePaymentMethodResponse {
	return pm.$type === 'BillingFinanceHousePaymentMethod';
}

// Type guard for BillingMSPPaymentMethodResponse
export function isBillingMSPPaymentMethod(pm: AnySpecificPaymentMethodResponse): pm is BillingMSPPaymentMethodResponse {
	return pm.$type === 'BillingMSPPaymentMethod';
}

// Type guard for BillingOffSystemPaymentMethodResponse
export function isBillingOffSystemPaymentMethod(
	pm: AnySpecificPaymentMethodResponse,
): pm is BillingOffSystemPaymentMethodResponse {
	return pm.$type === 'BillingOffSystemPaymentMethod';
}

// Type guard for BillingWalletPaymentMethodResponse
export function isBillingWalletPaymentMethod(
	pm: AnySpecificPaymentMethodResponse,
): pm is BillingWalletPaymentMethodResponse {
	return pm.$type === 'BillingWalletPaymentMethod';
}
